/**
 *
 * Routing buttons group
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { injectIntl, intlShape } from 'react-intl';
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { white, green500, grey500, green700 } from 'styles/colors';
import {
  TRAVELMODE_WALKING,
  TRAVELMODE_CYCLING,
  TRAVELMODE_STRAIGHT,
} from 'utils/directions/constants';
import messages from './messages';

const EditButton = styled(ToggleButton)`
  &.btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    font-size: 18px;
    color: ${grey500};
    border: 1px solid rgba(0, 0, 0, 0.2);
    &.active {
      color: ${white};
      background-color: ${green500};
    }
    &.active:hover {
      color: ${white};
      background-color: ${green700};
    }
    @media (min-width: 400px) {
      width: 48px;
      height: 48px;
      font-size: 24px;
    }
  }
`;

const Wrapper = styled(ToggleButtonGroup)`
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  &.btn-group > .btn {
    display: flex;
  }
`;

function RoutingGroup(props) {
  const { travelMode, onChange, intl } = props;
  return (
    <Wrapper
      type="radio"
      name="travelMode"
      value={travelMode}
      onChange={onChange}
    >
      <EditButton
        value={TRAVELMODE_WALKING}
        title={intl.formatMessage(messages.walking)}
      >
        <FontAwesomeIcon icon="walking" fixedWidth />
      </EditButton>
      <EditButton
        value={TRAVELMODE_CYCLING}
        title={intl.formatMessage(messages.bicycle)}
      >
        <FontAwesomeIcon icon="bicycle" fixedWidth />
      </EditButton>
      <EditButton
        value={TRAVELMODE_STRAIGHT}
        title={intl.formatMessage(messages.direct)}
      >
        <FontAwesomeIcon icon="long-arrow-alt-right" fixedWidth />
      </EditButton>
    </Wrapper>
  );
}

RoutingGroup.propTypes = {
  travelMode: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  intl: intlShape,
};

export default injectIntl(RoutingGroup);
